<template>
  <div class="nopads">
    <div class="row">
      <div class="col-6"
      >
        <span class="span-title">{{ $t('road_sign.sign_lane') }}</span>
          <input
              id="lane"
              :value="getVelhoLaneString(laneData)"
              type="text"
              class="form-control form-control-sm"
              disabled
          />
      </div>
      <div class="col-6">
        <span class="span-title">{{ $t('road_sign.side') }}</span>
          <input
              id="side"
              :value="getVelhoSideString(sideData)"
              type="text"
              class="form-control form-control-sm"
              disabled
          />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <span class="span-title">{{ $t('velho_conversion.tracks') }}</span>
          <input
              id="tracks"
              v-model="tracksFormated"
              type="text"
              class="form-control form-control-sm"
              disabled
          />
      </div>
    </div>
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {velhoHelper} from "@/components/mixins/VelhoMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";

export default {
    name: 'LocationDetails',
    components: {},
    mixins: [velhoHelper, conversionModelHelper, restApi],
    props: {
        sideData: {
            type: Number,
            default: -1
        },
        laneData: {
            type: Number,
            default: -1
        },
        trackData: {
            type: Array,
            default: Array
        }
    },
    data() {
        return {
        loading: false,
        }
    },

    computed: {
        tracksFormated () { return this.trackData.join(', ') }
    },
    methods: {

    }
}
</script>
